/*
    Options Dropdown
    Version:1.0
    Author:Rory Saxby & Jake Upshall
    Dependencies: jQuery

    EXAMPLE:

    *** Initialise ***

    var dropdowns = new logicjs.optionsDropdown({
        container: ".c-options-dropdown",
        item: ".c-options-dropdown__item",
        toggleCtrl: ".c-options-dropdown__toggle",
        view: ".c-options-dropdown__view",
        hiddenClass: ".c-options-dropdown__item--hidden"
    });

    *** Markup ***
    <div class="c-options-dropdown">
        <ul>
            <li>
                <div class="c-options-dropdown__item c-options-dropdown__item--hidden">
                    <button class="c-options-dropdown__toggle" type="button">
                        // dropdown control mark up goes here
                    </button>
                    <div class="c-options-dropdown__view">
                        // view markup goes here
                    </div>
                </div>
            </li>
            <li>
                <div class="c-options-dropdown__item c-options-dropdown__item--hidden">
                    <button class="c-options-dropdown__toggle" type="button">
                        // dropdown control mark up goes here
                    </button>
                    <div class="c-options-dropdown__view">
                        // view markup goes here
                    </div>
                </div>
            </li>
        </ul>
    </div>


 */


if (typeof logicjs === "undefined") logicjs = {};

logicjs.optionsDropdown = function (opts) {
    this.opts = {};

    // targets
    this.opts.containerClass = opts.containerClass || ".c-options-dropdown";
    this.opts.item = opts.item || ".c-options-dropdown__item";
    this.opts.toggleCtrl = opts.toggleCtrl || ".c-options-dropdown__toggle";
    this.opts.view = opts.view || ".c-options-dropdown__view";
    this.opts.hiddenClass = opts.hiddenClass || ".c-options-dropdown__item--hidden";

    // settings
    this.opts.toggleViews = opts.toggleCtrls || true;

    this.parentEmitUpdateFn = opts.parentEmitUpdateFn || null;

    this.handleDocClick = this.handleDocClick.bind(this);

    // run
    this.init();
};

logicjs.optionsDropdown.prototype.disableDropdowns = function () {
    for (var i = 0; i < this.itemList.length; i++) {
        this.resetSelected($(this.itemList[i]).find(this.opts.view));
    };
};

logicjs.optionsDropdown.prototype.closeDropdowns = function () {
    for (var i = 0; i < this.itemList.length; i++) {
        var item = $(this.itemList[i]);
        item.addClass(this.opts.hiddenClass);
        this.closeSelected(item.find(this.opts.view));
    };
};

logicjs.optionsDropdown.prototype.bindCtrls = function () {
    var _ = this;
    for (var i = 0; i < this.itemList.length; i++) {

        $(this.itemList[i]).find(this.opts.toggleCtrl).off('click').on('click', function (e) {
            e.preventDefault();
            _.toggleSelected($(this));
            _.bindDocClick();
        });
    };
};

logicjs.optionsDropdown.prototype.toggleSelected = function (ctrl) {
    this.selectedContainer = ctrl.parents(this.opts.item);

    if (this.selectedContainer.hasClass(this.opts.hiddenClass)) {
        if (this.opts.toggleViews) this.hideAll();
        this.selectedContainer.removeClass(this.opts.hiddenClass);
        this.openSelected(this.selectedContainer.find(this.opts.view));

    } else {
        this.selectedContainer.addClass(this.opts.hiddenClass);
        this.closeSelected(this.selectedContainer.find(this.opts.view));
    };

    if (this.parentEmitUpdateFn) this.parentEmitUpdateFn(this.selectedContainer, "item click");
};

logicjs.optionsDropdown.prototype.resetSelected = function (view) {
    view.css({
        height: ""
    });
};

logicjs.optionsDropdown.prototype.openSelected = function (view) {
    view.css({
        height: view[0].scrollHeight + "px"
    });
};

logicjs.optionsDropdown.prototype.closeSelected = function (view) {
    view.css({
        height: 0
    });
};

logicjs.optionsDropdown.prototype.bindDocClick = function () {
    document.addEventListener('mouseup', this.handleDocClick);
};

logicjs.optionsDropdown.prototype.unbindDocClick = function () {
    document.removeEventListener('mouseup', this.handleDocClick);
};

logicjs.optionsDropdown.prototype.handleDocClick = function (e) {
    e.stopImmediatePropagation();
    var target = $(e.target);
    if (!target.parents().hasClass(this.opts.containerClass) && !target.hasClass(this.opts.containerClass)) {
        this.hideAll();
        this.unbindDocClick();
        if (this.parentEmitUpdateFn) this.parentEmitUpdateFn(this.selectedContainer, "document click");
        return;
    };
};

logicjs.optionsDropdown.prototype.hideAll = function () {
    for (var i = 0; i < this.itemList.length; i++) {
        var item = $(this.itemList[i]);
        item.addClass(this.opts.hiddenClass);
        this.closeSelected(item.find(this.opts.view));
    };
};

logicjs.optionsDropdown.prototype.setTargets = function () {
    this.container = $('.' + this.opts.containerClass);
    this.itemList = this.container.find(this.opts.item);
};

logicjs.optionsDropdown.prototype.disable = function (instance) {
    this.disableDropdowns();
    this.unbindDocClick();
};

logicjs.optionsDropdown.prototype.enable = function () {
    this.closeDropdowns();
};

logicjs.optionsDropdown.prototype.init = function () {
    this.setTargets();
    this.bindCtrls();
};